import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { UpNext } from '../upNext/upNext';
import { useStyles } from '../../../common/hooks/useStyles';
import { getDiscoveryContainerStyleObject } from './discoveryContainer.style';
import { discoverySelector } from '../../../common/store/selectors/discovery.selector';
import { isEmpty } from '../../../common/utils/utils';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { splitViewSelector } from '../../../common/store/selectors/splitView.selector';
import { adsDataSelector } from '../../../common/store/selectors/adsData.selector';
import { SkippableContent } from '../skippableContent/skippableContent';
import { systemGeneralSelector } from '../../../common/store/selectors/systemGeneral.selector';
import { ErrorBoundary } from '../../../common/components/errorBoundary/errorBoundary';

const DISCOVERY_PLUGIN = 'Discovery';

export const DiscoveryContainer: FunctionComponent = () => {
  const nextVideo = useSelector(discoverySelector.nextVideo);
  const playerSize = useSelector(playerDataSelector.playerSize);
  const splitViewRatio = useSelector(splitViewSelector.splitViewRatio);
  const adBreak = useSelector(adsDataSelector.adBreak);
  const isFatalError = useSelector(systemGeneralSelector.isFatalError);

  const styles = useStyles(getDiscoveryContainerStyleObject, []);
  const { discoveryContainerStyle } = styles;

  const showUpNextByPlayerSizes = playerSize !== 'small' && playerSize !== 'extraSmall';
  const showUpNext = nextVideo === 'upNext' && isEmpty(splitViewRatio) && showUpNextByPlayerSizes && !adBreak;

  const showSkippableContentByPlayerSizes = playerSize !== 'extraSmall';
  const showSkippableContent = nextVideo === 'skippableContent' && isEmpty(splitViewRatio) && showSkippableContentByPlayerSizes && !adBreak;

  return (
    <ErrorBoundary pluginName={DISCOVERY_PLUGIN}>
      {
        isFatalError ? null :
          (
            <div style={discoveryContainerStyle} onClick={(e: MouseEvent): void => e.stopPropagation()}>
              {showUpNext ? <UpNext /> : null}
              {showSkippableContent ? <SkippableContent /> : null}
            </div>
          )
      }
    </ErrorBoundary>
  );
};
